import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export async function joinWaitlist(email, source, faith, guard = {}) {
  const ref = window.localStorage.getItem("lunelle-ref") || undefined;
  const res = await axios.post(`${BASE}/api/waitlist`, { email, source, faith, consent: true, ref, ...guard });
  return res.data;
}

export async function getSpot(token) {
  const res = await axios.get(`${BASE}/api/waitlist/spot`, { params: { token } });
  return res.data;
}

export async function confirmEmail(token) {
  const res = await axios.post(`${BASE}/api/waitlist/confirm`, { token });
  return res.data;
}

export const captureRef = () => {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (ref && /^[\w-]{4,24}$/.test(ref)) window.localStorage.setItem("lunelle-ref", ref);
  return ref;
};

export async function leaveWaitlist(token) {
  const res = await axios.post(`${BASE}/api/waitlist/unsubscribe`, { token });
  return res.data;
}

export async function getWaitlistCount() {
  if (!BASE) return 0;
  const res = await axios.get(`${BASE}/api/waitlist/count`);
  return res.data?.count ?? 0;
}

export const goTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
